$(document).on('turbolinks:load', function() {
  if (typeof gtag === 'function') {
    gtag('config', 'pageview', {'page_path': window.location.pathname});
  }
});
